<template>

<app-wrapper>

	<app-text>

        <app-group :bordered="true">

            <h2>{{ page.business_profile_password_current }}</h2>

            <app-group>

                <app-input-password :label="page.business_profile_password_current_label" v-model="inputs.oldPassword" :errored="errored.oldPassword" :placeholder="page.business_profile_password_current_placeholder" />

            </app-group>

            <h2>{{ page.business_profile_password_new }}</h2>

            <app-group>

                <app-input-password :label="page.business_profile_password_new_label" note="Must be at least 8 characters and include at least one letter and one number." v-model="inputs.newPassword" :errored="errored.newPassword" :placeholder="page.business_profile_password_new_placeholder" />
                <app-input-password :label="page.business_profile_password_confirm_label" v-model="inputs.newPasswordConfirm" :errored="errored.newPassword" :placeholder="page.business_profile_password_confirm_placeholder" />

            </app-group>

        </app-group>

		<app-group :row="true" :center="true">

			<app-button text="Save changes" :success="is.saved" :fail="is.errored" :disabled="!is.valid" :loading="is.submitting" v-on:click="onSaveClick" />

		</app-group>

	</app-text>

</app-wrapper>

</template>

<script>

import mixinForm from '@/mixin/form.js'

export default {

	mixins: [mixinForm],

	data: function() {

		return {
			stayAfterSave: true,
			inputs: {
				oldPassword: '',
				newPassword: '',
				newPasswordConfirm: ''
			},
			rules: {
				oldPassword: {
					required: true,
					minlength: 8
				},
				newPassword: {
					required: true,
					minlength: 8,
					match: 'newPasswordConfirm'
				},
				newPasswordConfirm: {
					required: true,
					minlength: 8,
					match: 'newPassword'
				}
			}
		}

	},

	methods: {

		resetValues: function() {

			this.inputs.oldPassword = ''
			this.inputs.newPassword = ''
			this.inputs.newPasswordConfirm = ''

		},

		onSaveClick: function() {

			this.save('account/profile/password', this.inputs).then(function() {


			}.bind(this))

		}

	}

}

</script>